import { Box, Typography } from '@mui/material';
import { TriangleAlert } from 'lucide-react';
import type { ReactElement } from 'react';

import { Card, Icon } from '@/ui/kit';

/**
 * Apercu du **seul bandeau**, avec le message saisi.
 *
 * Ce n'est pas un faux ecran d'accueil : un decor de chiffres inventes laisserait
 * croire a un rendu verifie, alors que le mobile n'affiche pas encore ce message
 * (MOB-26, #523). Le bandeau reprend l'encre et la surface « attention » du kit,
 * la famille de couleurs que le mobile utilise pour un avertissement ; le titre
 * est celui de la maquette.
 *
 * Message vide : le serveur n'ajoute alors **rien** au corps du 503, et l'apercu
 * le dit au lieu de dessiner un bandeau vide.
 */
export const MaintenancePreview = ({ message }: { readonly message: string }): ReactElement => {
  const text = message.trim();

  return (
    <Card title="Aperçu dans l’application" subtitle="Indicatif : le bandeau n’est pas encore affiché par le mobile.">
      {text === '' ? (
        <Typography sx={{ fontSize: 14, color: 'tokens.textMuted' }}>
          Aucun message : le corps de la réponse 503 ne portera que le code d’erreur.
        </Typography>
      ) : (
        <Box
          role="note"
          aria-label="Aperçu du bandeau de maintenance"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 0.75,
            p: 1.5,
            borderRadius: '14px',
            bgcolor: 'tokens.accentYellowSoft',
            color: 'tokens.accentYellowStrong',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Icon icon={TriangleAlert} size={16} />
            <Typography component="p" sx={{ fontSize: 13, fontWeight: 700 }}>
              Maintenance prévue
            </Typography>
          </Box>
          <Typography component="p" sx={{ fontSize: 13, lineHeight: '18px', overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>
            {text}
          </Typography>
        </Box>
      )}
    </Card>
  );
};
